import React from "react";

import {
  CURTAIN_TOOLBOX_SIZE_OPTIONS,
  CURTAIN_TOOLBOX_TYPE_OPTIONS,
} from "../../../data";
import { FieldsRow, StructureCard } from "../OpenBoxQuotes/BoxStructureFields";
import { NumberField, SelectField } from "../OpenBoxQuotes/FormFields";
import {
  useRoofBoxAccessories,
} from "./AccessoriesCards";
import { roofKey } from "./BoxStructureCards";

export const ToolboxCard = () => {
  const { data, patch } = useRoofBoxAccessories();
  const item = data.toolbox;

  return (
    <StructureCard
      enabled={item.enabled}
      titleKey={roofKey("CARDS.TOOLBOX")}
      onToggle={(enabled) => patch("toolbox", { enabled })}
    >
      <FieldsRow>
        <SelectField
          labelKey={roofKey("FIELDS.TYPE")}
          value={item.selectedOption}
          options={CURTAIN_TOOLBOX_TYPE_OPTIONS}
          onChange={(selectedOption) => patch("toolbox", { selectedOption })}
          grow
        />
        <SelectField
          labelKey={roofKey("FIELDS.SIZE")}
          value={item.size}
          options={CURTAIN_TOOLBOX_SIZE_OPTIONS}
          onChange={(size) => patch("toolbox", { size })}
          grow
        />
        <NumberField
          labelKey={roofKey("FIELDS.QUANTITY")}
          value={item.quantity}
          onChange={(quantity) => patch("toolbox", { quantity })}
          shortStepper
        />
      </FieldsRow>
    </StructureCard>
  );
};

export const OpenBasketCard = () => {
  const { data, patch } = useRoofBoxAccessories();
  const item = data.openBasket;

  return (
    <StructureCard
      enabled={item.enabled}
      titleKey={roofKey("CARDS.OPEN_BASKET")}
      onToggle={(enabled) => patch("openBasket", { enabled })}
    >
      <FieldsRow>
        <NumberField
          labelKey={roofKey("FIELDS.LENGTH_MM")}
          value={item.length}
          onChange={(length) => patch("openBasket", { length })}
          grow
        />
        <NumberField
          labelKey={roofKey("FIELDS.WIDTH_MM")}
          value={item.width}
          onChange={(width) => patch("openBasket", { width })}
          grow
        />
        <NumberField
          labelKey={roofKey("FIELDS.HEIGHT_MM")}
          value={item.height}
          onChange={(height) => patch("openBasket", { height })}
          grow
        />
        <NumberField
          labelKey={roofKey("FIELDS.QUANTITY")}
          value={item.quantity}
          onChange={(quantity) => patch("openBasket", { quantity })}
          grow
        />
      </FieldsRow>
    </StructureCard>
  );
};
